@if (!editMode || (editMode && fieldConfig.editReadOnly)) {
  <div>
    <!-- <span *ngIf="modelDate">{{modelDate}}</span> -->
    {{ formattedDate }}
  </div>
} @else {
  <!--<mat-form-field [owlDateTimeTrigger]="dt3">
  <span>UTC</span>
  <input [owlDateTime]="dt3" matInput [errorStateMatcher]="matcher" [(ngModel)]="modelDate"
    (ngModelChange)="onModelChange()">
    <mat-icon matSuffix>event</mat-icon>
    <mat-error *ngFor="let v of fieldConfig.validators">
      <span *ngIf="condition(v)">{{message(v)}}</span>
    </mat-error>
  </mat-form-field>
  <owl-date-time #dt3 [pickerType]="'timer'"></owl-date-time>-->
  <div class="time-form-container">
    <mat-form-field>
      <div class="form-container">
        <input
          [placeholder]="timePlaceholder"
          matInput
          [ngxTimepicker]="toggleIcon"
          [format]="24"
          [value]="modelTime" />
        <ngx-material-timepicker-toggle [for]="toggleIcon" class="toggle-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 30 30"
            width="18px"
            height="18px"
            ngxMaterialTimepickerToggleIcon>
            <path
              d="M15,3C8.373,3,3,8.373,3,15c0,6.627,5.373,12,12,12s12-5.373,12-12C27,8.373,21.627,3,15,3z M16,16H7.995 C7.445,16,7,15.555,7,15.005v-0.011C7,14.445,7.445,14,7.995,14H14V5.995C14,5.445,14.445,5,14.995,5h0.011 C15.555,5,16,5.445,16,5.995V16z" />
          </svg>
        </ngx-material-timepicker-toggle>
        <ngx-material-timepicker #toggleIcon (timeSet)="onTimeChange($event)"></ngx-material-timepicker>
      </div>
    </mat-form-field>
  </div>
}
